(function () {
  'use strict';
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  let heroFrame = 0;

  function setupTrack(row) {
    if (instances.has(row)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const dots = document.querySelector('[data-sx-dots="' + row.id + '"]');
    const buttons = dots ? Array.from(dots.querySelectorAll('button')) : [];
    const slides = Array.from(row.children);
    let active = 0;
    let drag = null;
    let timer = null;
    let interrupted = false;
    let clickBlocked = false;
    let visible = false;
    let frame = 0;

    function movable() { return row.scrollWidth > row.clientWidth + 4; }
    function update() {
      frame = 0;
      if (dots) dots.hidden = !movable();
      const start = row.getBoundingClientRect().left;
      let closest = Infinity;
      slides.forEach(function (slide, index) {
        const distance = Math.abs(slide.getBoundingClientRect().left - start);
        if (distance < closest) { closest = distance; active = index; }
      });
      const max = row.scrollWidth - row.clientWidth;
      let lastStop = -Infinity;
      buttons.forEach(function (button, index) {
        const position = slides[index] ? slides[index].getBoundingClientRect().left - start + row.scrollLeft : 0;
        const stop = Math.max(0, Math.min(position, max));
        button.hidden = stop - lastStop < 4;
        if (!button.hidden) lastStop = stop;
        if (index === active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      row.tabIndex = movable() ? 0 : -1;
    }
    function scheduleUpdate() { if (!frame) frame = requestAnimationFrame(update); }
    function go(index, behaviour) {
      const slide = slides[index];
      if (!slide) return;
      const offset = slide.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft;
      row.scrollTo({ left: offset, behavior: motionQuery.matches ? 'auto' : (behaviour || 'smooth') });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function interrupt() { interrupted = true; stop(); }
    function start() {
      stop();
      if (row.dataset.sxAutoplay !== 'true' || interrupted || motionQuery.matches || !visible || document.hidden || !movable() || (window.Shopify && Shopify.designMode)) return;
      timer = setInterval(function () {
        if (row.matches(':hover') || row.contains(document.activeElement)) return;
        const atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
        go(atEnd ? 0 : Math.min(active + 1, slides.length - 1));
      }, Math.max(4, Number(row.dataset.sxInterval) || 7) * 1000);
    }
    buttons.forEach(function (button, index) { button.addEventListener('click', function () { interrupt(); go(index); }, { signal: signal }); });
    row.addEventListener('scroll', scheduleUpdate, { passive: true, signal: signal });
    row.addEventListener('pointerdown', function (event) {
      interrupt();
      clickBlocked = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !movable() || event.target.closest('button,input,select,textarea')) return;
      drag = { x: event.clientX, left: row.scrollLeft, id: event.pointerId, moved: false };
    }, { signal: signal });
    row.addEventListener('pointermove', function (event) {
      if (!drag || drag.id !== event.pointerId) return;
      const distance = event.clientX - drag.x;
      if (!drag.moved && Math.abs(distance) < 7) return;
      if (!drag.moved) { drag.moved = true; row.classList.add('is-dragging'); row.setPointerCapture(event.pointerId); }
      event.preventDefault();
      row.scrollLeft = drag.left - distance;
    }, { signal: signal });
    function finish(event) {
      if (!drag || event.pointerId !== drag.id) return;
      clickBlocked = drag.moved;
      drag = null;
      row.classList.remove('is-dragging');
      if (row.hasPointerCapture(event.pointerId)) row.releasePointerCapture(event.pointerId);
    }
    row.addEventListener('pointerup', finish, { signal: signal });
    row.addEventListener('pointercancel', finish, { signal: signal });
    row.addEventListener('lostpointercapture', finish, { signal: signal });
    row.addEventListener('dragstart', function (event) { event.preventDefault(); }, { signal: signal });
    row.addEventListener('click', function (event) {
      if (!clickBlocked) return;
      event.preventDefault(); event.stopPropagation(); clickBlocked = false;
    }, { capture: true, signal: signal });
    row.addEventListener('wheel', interrupt, { passive: true, signal: signal });
    row.addEventListener('focusin', interrupt, { signal: signal });
    row.addEventListener('keydown', function (event) {
      if (event.target !== row) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); interrupt(); go(Math.max(0, Math.min(slides.length - 1, active + (event.key === 'ArrowRight' ? 1 : -1))));
      }
    }, { signal: signal });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); }, { signal: signal });
    motionQuery.addEventListener('change', start, { signal: signal });
    const observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; visible ? start() : stop(); });
    observer.observe(row);
    const resize = new ResizeObserver(function () { update(); start(); });
    resize.observe(row);
    update();
    instances.set(row, function () { controller.abort(); observer.disconnect(); resize.disconnect(); stop(); if (frame) cancelAnimationFrame(frame); });
  }

  function reveal(root) {
    const targets = root.querySelectorAll('[data-sx-reveal]:not([data-sx-observed])');
    if (motionQuery.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (motionQuery.matches || !entry.target.isConnected) return;
        if (entry.target.closest('[data-sx-motion="false"]')) return;
        entry.target.animate([{ opacity: .18, transform: 'translateY(22px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 650, easing: 'cubic-bezier(.2,.75,.3,1)' });
      });
    }, { threshold: .08 });
    targets.forEach(function (target) { target.dataset.sxObserved = 'true'; observer.observe(target); });
  }

  function updateHero() {
    heroFrame = 0;
    document.querySelectorAll('[data-sx-hero]').forEach(function (hero) {
      const bounds = hero.getBoundingClientRect();
      if (motionQuery.matches || hero.dataset.sxMotion === 'false' || window.innerWidth < 1000) {
        hero.style.removeProperty('--sx-hero-zoom'); hero.style.removeProperty('--sx-hero-shift'); return;
      }
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
      const travel = Math.max(0, Math.min(1, -bounds.top / bounds.height));
      hero.style.setProperty('--sx-hero-zoom', String(1 + travel * .055));
      hero.style.setProperty('--sx-hero-shift', (travel * 18) + 'px');
    });
  }
  function scheduleHero() { if (!heroFrame) heroFrame = requestAnimationFrame(updateHero); }
  function init(root) {
    root.querySelectorAll('[data-sx-track]').forEach(setupTrack);
    reveal(root); scheduleHero();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  window.addEventListener('scroll', scheduleHero, { passive: true });
  window.addEventListener('resize', scheduleHero, { passive: true });
  motionQuery.addEventListener('change', scheduleHero);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, row) { if (event.target.contains(row)) { dispose(); instances.delete(row); } });
  });
  document.addEventListener('shopify:block:select', function (event) {
    const slide = event.target.closest('.sx-flavour,.sx-review,.sx-benefits__grid>article');
    if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
  });
})();
